import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: LIGHT_GREY,
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
  },
  image: {
    borderRadius: 4,
    width: "100%",
    height: theme.spacing(30),
    objectFit: "contain",
  },
}));
